import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import history from 'utils/history';

// styles
import './style.scss';

// antd component
import { List, Empty } from 'antd';

// assets
import CustomIcons from 'components/CustomIcons';

// global user
import { useGetLocalUser, useGetLocalActiveChild, useGetUserChildren } from 'engine/Contexts/User.context';

// custom react-multi-date-picker
import { timeFormat, dateFormat } from 'utils/moment/moment.constant';

// utils
import { getObjId, sortByKey } from 'utils/helpers/helper.general';

function CoursesList({
  dataSourse,
  selectedDate,
  showAll,
  appointments,
  // states
  loading,
  // default props
  className,
  style,
}) {
  const mainClassNames = classNames('courses-mobile-wrapper', className);

  const localUser = useGetLocalUser()();
  const localActiveChild = useGetLocalActiveChild()();
  const children = useGetUserChildren()();

  const userStudents = localUser?.role == 'parent' ? children : [];

  const getMaxHeight = () => {
    //45 - header height
    //60 - from .main-content-container (max-height css function)
    //57 - .courses-list-wrapper__switch height
    //241 - calendar height (from design. Update if actual height will be different)
    return window.innerHeight - 45 - 60 - 57 - 15 - 241;
  };

  const getCoursesStudents = useCallback(
    courseStudents => {
      if (
        !(
          userStudents &&
          Array.isArray(userStudents) &&
          userStudents.length > 0
        )
      )
        return [];

      const studentsNames = userStudents
        ?.map(std =>
          courseStudents.find(el => getObjId(el) == getObjId(std))
            ? {
                _id: getObjId(std),
                name: std?.description?.firstname,
              }
            : null,
        )
        .filter(el => el !== null);
      return studentsNames;
    },
    [userStudents],
  );

  const clickHandle = useCallback(
    itemID => {
      localUser?.role !== 'parent' &&
        history.push({
          pathname: `/сours/${itemID}`,
          search: '',
          hash: '',
          state: {
            onDate: selectedDate || false,
            goBack: '/сours',
            goBackTitle: 'Cours',
          },
        });
    },
    [localUser?.role, selectedDate, history],
  );

  const showStdsNames = useCallback(
    tdsNames => {
      return (
        showAll &&
        localUser?.role == 'parent' &&
        tdsNames?.length > 0 && (
          <span className="list-items-meta-student">
            {tdsNames?.map((element, nx) => {
              const sep = tdsNames.length - 1 != nx ? ', ' : '';
              return (
                <>
                  <span
                    className={`name ${
                      getObjId(element) == getObjId(localActiveChild)
                        ? 'active'
                        : ''
                    }`}
                  >
                    {element?.name}
                  </span>
                  {sep}
                </>
              );
            })}
          </span>
        )
      );
    },
    [localUser?.role, showAll, localActiveChild],
  );

  const courseItem = useCallback(
    item => {
      const studentsNames =
        !!item?.students && getCoursesStudents(item?.students);
      const courseClass = item?.class_info?.title;

      return (
        <List.Item
          key={item?._id + '-course-list'}
          className="list-items"
          onClick={() => !item?.appointmentDate && clickHandle(item?._id)}
        >
          <List.Item.Meta
            title=""
            className="list-items-meta"
            description={
              <>
                {item?.course_time_start && (
                  <span className="list-items-meta-start-time">
                    {moment(item?.course_time_start).format(timeFormat)}
                  </span>
                )}

                <div className="list-item-meta-wrapper">
                  <div className="list-item-meta-subject-wrapper">
                    <span className="list-items-meta-subject-name">
                      {item?.subject?.name}
                    </span>

                    {!!item?.students && showStdsNames(studentsNames)}

                    {!!courseClass && localUser?.role == 'teacher' && (
                      <span className="list-items-meta-teacher">
                        {courseClass}
                      </span>
                    )}

                    <div className="list-items-meta-wrapper-class-student">
                      {!item?.appointmentDate && (
                        <span className="list-items-meta-class-room">
                          {item?.class_room ? item?.class_room : '--'}
                        </span>
                      )}
                      {!!item?.appointmentDate && (
                        <span className="list-items-meta-mark appointment-mark">
                          <CustomIcons type="calendar" />
                        </span>
                      )}
                    </div>
                  </div>

                  {/*

              --- For Future sprints

              {item?.homework &&
              item?.lesson &&
              activeSubject &&
              activeSubjectId === item?._id && (
                <div className="list-items-meta-wrapper-extra-data">
                  <div className="extra-data-homework">
                    <span className="extra-data-homework-title">
                      Devoir(s)
                    </span>

                    <span className="extra-data-homework-item">
                      {item?.homework}
                    </span>
                  </div>
                  <div className="extra-data-lesson">
                    <span className="extra-data-lesson-title">
                      Leçon(s)
                    </span>

                    <span className="extra-data-lesson-item">
                      {item?.lesson}
                    </span>
                  </div>
                </div>
              )} */}
                </div>
              </>
            }
          />
        </List.Item>
      );
    },
    [history, localUser],
  );

  let dataSourseNew =
    (dataSourse &&
      dataSourse.map(el => {
        return {
          ...el,
          title: `<span className="time">${moment(el?.course_time_start).format(
            timeFormat,
          )}</span> <span className="cours-name">${el?.subject?.name}</span>`,
        };
      })) ||
    [];

  // Add appointments to the list and adapt it
  if (!!appointments && Array.isArray(appointments)) {
    dataSourseNew = [...dataSourseNew, ...appointments];
  }

  dataSourseNew = dataSourseNew
    ?.map(el => {
      if (!!el?.course_time_start) {
        return el;
      }
      if (!!el?.adminAnswer) {
        return {
          ...el,
          course_time_start: el?.adminAnswer?.slot?.timeFrom,
          subject: {
            name: el?.title,
          },
          students: [el?.student],
          title: `<span className="time">${moment(el?.adminAnswer?.slot?.timeFrom).format(
            timeFormat,
          )}</span> <span className="cours-name">${el?.title}</span>`,
        };
      } else {
        return el;
      }
    })
    .sort(sortByKey('title'));

  return (
    <div
      className={mainClassNames}
      style={{ ...style, maxHeight: `${getMaxHeight()}px` }}
    >
      <List
        header=""
        className="courses-mobile-wrapper__list"
        dataSource={dataSourseNew}
        renderItem={courseItem}
        loading={loading}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Il n'y a pas de cours à cette date."
            />
          ),
        }}
      />
    </div>
  );
}

CoursesList.defaultProps = {
  showAll: false,
  loading: false,
};
CoursesList.propTypes = {
  dataSourse: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.array.isRequired,
  ]),
  loading: PropTypes.bool,
  showAll: PropTypes.bool,
};

export default CoursesList;
